/**
 * Utility functions for extracting video IDs from various video platform URLs
 */

// TikTok embed dimensions (9:16 aspect ratio for vertical videos)
export const TIKTOK_ASPECT_RATIO = '177.78%'; // 16/9 * 100
export const TIKTOK_MAX_WIDTH = '325px';

/**
 * Extract YouTube video ID from a YouTube URL
 * Supports: youtube.com/watch, youtu.be, youtube.com/shorts
 */
export const getYouTubeVideoId = (url: string): string | null => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};

/**
 * Extract TikTok video ID from a TikTok URL
 * Supports: tiktok.com/@username/video/ID
 * Note: vm.tiktok.com short URLs cannot be directly embedded using this method
 * and will fall back to native video player (getTikTokVideoId returns null for them)
 */
export const getTikTokVideoId = (url: string): string | null => {
  const regExp = /tiktok\.com\/@[\w.-]+\/video\/(\d+)/;
  const match = url.match(regExp);
  return match ? match[1] : null;
};
